import { Injectable } from '@angular/core';
import { EnvironmentService } from '@lib/core/environment';
import { AuthHttpClient } from '@proget-shared/auth-http-client';
import { catchError, map, Observable, of } from 'rxjs';

import { SearchResultMapper } from './mapper/search-result.mapper';
import { SearchResult } from './model';

@Injectable({ providedIn: 'root' })
export class SearcherRepository {
  constructor(private httpClient: AuthHttpClient, private environment: EnvironmentService) {}

  public get(query: string): Observable<SearchResult> {
    return this.httpClient
      .get(`${this.environment.apiUrl}/search`, { params: { query, spinner: 'false' } })
      .pipe(
        map(SearchResultMapper.map),
        catchError(() => of(new SearchResult()))
      );
  }
}
